<template>
  <div class="notation-display">
    <p>Notation display placeholder...</p>
  </div>
</template>

<script>
export default {
  name: 'NotationDisplay',
  props: {
    minimized: Boolean,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.notation-display {
  padding: 20px;
}
</style>
